var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.508,
    height: 12.477,
    viewBox: "0 0 18.508 12.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#768092;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.5,7.383A9.951,9.951,0,0,0,2.25,13.621a9.983,9.983,0,0,0,18.508,0A9.951,9.951,0,0,0,11.5,7.383Zm0,10.4a4.161,4.161,0,1,1,4.206-4.16A4.195,4.195,0,0,1,11.5,17.781Zm0-6.656a2.5,2.5,0,1,0,2.524,2.5A2.518,2.518,0,0,0,11.5,11.126Z",
    transform: "translate(-2.25 -7.383)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.83fffce2602b8a198b799e7e95015973.svg";
export { ForwardRef as ReactComponent };